export default "__VITE_ASSET__rqvRUS5C__"